import agency from 'i18n/adsimple/ru/agency.yml'
import auth from 'i18n/adsimple/ru/auth.yml'
import autoreplenish from 'i18n/adsimple/ru/autoreplenish.yml'
import banners from 'i18n/adsimple/ru/banners.yml'
import billing from 'i18n/adsimple/ru/billing.yml'
import common from 'i18n/adsimple/ru/common.yml'
import oauth from 'i18n/adsimple/ru/oauth.yml'
import promised_payment from 'i18n/adsimple/ru/promised_payment.yml'
import pulse from 'i18n/adsimple/ru/pulse.yml'
import recommendations from 'i18n/adsimple/ru/recommendations.yml'
import referral from 'i18n/adsimple/ru/referral.yml'
import services from 'i18n/adsimple/ru/services.yml'
import statistics from 'i18n/adsimple/ru/statistics.yml'
import user from 'i18n/adsimple/ru/user.yml'
import finance from 'i18n/adsimple/ru/finance.yml'
import industries from 'i18n/adsimple/ru/industries.yml'
import tickets from 'i18n/adsimple/ru/tickets.yml'
import form_errors from 'i18n/adsimple/ru/form_errors.yml'
import payment_order from 'i18n/adsimple/ru/payment_order.yml'
import partners_program from 'i18n/adsimple/ru/partners_program.yml'
import reward_calculator from 'i18n/adsimple/ru/reward_calculator.yml'
import campaigns_editor from 'i18n/adsimple/ru/campaigns_editor.yml'
import advertisers from 'i18n/adsimple/ru/advertisers.yml'
import media_planner from 'i18n/adsimple/ru/media_planner.yml'
import countries from 'i18n/adsimple/ru/countries.yml'
import cookie_banner from 'i18n/adsimple/ru/cookie-banner.yml'
import accounts_marketplace from 'i18n/adsimple/ru/accounts_marketplace.yml'
import audits from 'i18n/adsimple/ru/audits.yml'
import benchmarks from 'i18n/adsimple/ru/benchmarks.yml'
import payment_profiles from 'i18n/adsimple/ru/payment_profiles.yml'
import wallets from 'i18n/adsimple/ru/wallets.yml'
import invoices from 'i18n/adsimple/ru/invoices.yml'

export default {
  audits,
  benchmarks,
  banners,
  common,
  services,
  agency,
  statistics,
  referral,
  user,
  pulse,
  billing,
  autoreplenish,
  oauth,
  finance,
  wallets,
  payment_profiles,
  promised_payment,
  recommendations,
  industries,
  auth,
  tickets,
  form_errors,
  payment_order,
  partners_program,
  reward_calculator,
  campaigns_editor,
  advertisers,
  media_planner,
  countries,
  cookie_banner,
  accounts_marketplace,
  invoices,
}
